import request from '@/utils/zsm-requets'
const agent = '/zsm/api/agent/'
/**
 * 创建介绍人
 *  id 手机号
 * idCard 身份证号
 * name 名字
 */
export function createAgent(params) {
  return request({
    url: agent + 'create',
    method: 'post',
    params
  })
}

/*
介绍人列表
 id 手机号
 agentDict 类型
 */
export function listDataAgent(params) {
  return request({
    url: agent + 'listData',
    method: 'post',
    params
  })
}

/*
 修改介绍人信息
 id 手机号
 agentDict 类型
 */
export function updateAgent(params) {
  return request({
    url: agent + 'update',
    method: 'post',
    params
  })
}
/*
 获取介绍人信息
 id 手机号
 agentDict 类型
 */
export function getAgent(params) {
  return request({
    url: agent + 'get',
    method: 'post',
    params
  })
}
